export default "__VITE_ASSET__x9yBYgKI__"